module.exports = __webpack_public_path__ + "static/media/banner-apple-ppfa.eb80d0cf.png";